import React from "react";

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    lineHeight: "1.6",
    color: "#333",
  },
  header: {
    fontSize: "2rem",
    color: "#0056b3",
  },
  subHeader: {
    fontSize: "1.5rem",
    color: "#003366",
    marginTop: "20px",
  },
  paragraph: {
    marginBottom: "20px",
  },
  list: {
    marginLeft: "20px",
    marginBottom: "20px",
  },
  listItem: {
    marginBottom: "10px",
  },
  address: {
    marginTop: "20px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Privacy Policy</h1>
      <p style={styles.paragraph}>
        <strong>Effective Date:</strong> 20 Jan 2025
      </p>
      <p style={styles.paragraph}>
        Bizwit Research & Consulting LLP ("we," "our," "us") values your trust and is committed to protecting your privacy. This Privacy Policy explains how we collect, use, share, and safeguard your information when you use Bizwit Insights ("the Service"), a reports access platform that allows users to access and download various research reports under a subscription model.
      </p>
      <p style={styles.paragraph}>
        By accessing or using Bizwit Insights, you accept the practices described in this Privacy Policy. If you do not agree with the terms, please discontinue using the Service.
      </p>
      <hr />
      <h2 style={styles.subHeader}>1. Information We Collect</h2>
      <p style={styles.paragraph}>We collect various types of information to provide and improve our Service.</p>
      <h3 style={styles.subHeader}>1.1. Personal Information</h3>
      <p style={styles.paragraph}>
        When you register or interact with Bizwit Insights, we may collect personal data, including but not limited to:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Account Registration: Name, email address, username, password, contact number.</li>
        <li style={styles.listItem}>Billing Information: Credit/debit card details, billing address, transaction history.</li>
        <li style={styles.listItem}>Contact Information: Any information you provide when you contact us for support or feedback.</li>
      </ul>
      <h3 style={styles.subHeader}>1.2. Non-Personal Information</h3>
      <p style={styles.paragraph}>
        We may also collect non-identifiable information such as:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Device Information: Type of device, operating system, browser type, and IP address.</li>
        <li style={styles.listItem}>Usage Data: Pages viewed, time spent on pages, clickstream data, and the frequency of access.</li>
      </ul>
      <h3 style={styles.subHeader}>1.3. Cookies and Similar Technologies</h3>
      <p style={styles.paragraph}>
        We use cookies, beacons, tags, and scripts to collect and track information and improve and analyze our Service. You can control the use of cookies at the browser level, but if you choose to disable cookies, it may limit your use of certain features or functions of our Service.
      </p>
      <h2 style={styles.subHeader}>2. How We Use Your Information</h2>
      <p style={styles.paragraph}>We use the information we collect for the following purposes:</p>
      <h3 style={styles.subHeader}>2.1. To Provide Our Service</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>Account Management: To set up and manage your account, provide customer support, and process transactions.</li>
        <li style={styles.listItem}>Subscription Services: To provide access to reports, manage subscriptions, and notify you about changes or updates.</li>
      </ul>
      <h3 style={styles.subHeader}>2.2. To Improve Our Service</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>Performance Monitoring: To analyze usage patterns, troubleshoot technical issues, and improve user experience.</li>
        <li style={styles.listItem}>Feature Development: To develop new features, products, or services based on user feedback and behavior.</li>
      </ul>
      <h3 style={styles.subHeader}>2.3. Communication</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          Transactional Communication: To send you confirmations, invoices, technical notices, updates, and administrative messages.
        </li>
        <li style={styles.listItem}>
          Marketing Communication: To provide promotional materials, newsletters, and information about our services. You can opt-out of marketing communications at any time.
        </li>
      </ul>
      <h3 style={styles.subHeader}>2.4. Compliance and Security</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>Legal Compliance: To comply with legal obligations, such as preventing fraud, enforcing our terms and conditions, and protecting our rights.</li>
      </ul>
      <h2 style={styles.subHeader}>3. Information Sharing and Disclosure</h2>
      <p style={styles.paragraph}>
        We do not sell or rent your personal information to third parties. However, we may share your information in the following circumstances:
      </p>
      <h3 style={styles.subHeader}>3.1. Service Providers</h3>
      <p style={styles.paragraph}>
        We may share your information with third-party vendors and service providers who perform services on our behalf, such as payment processing, data analysis, marketing support, and customer service.
      </p>
      <h3 style={styles.subHeader}>3.2. Business Transfers</h3>
      <p style={styles.paragraph}>
        In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred to the new owner.
      </p>
      <h3 style={styles.subHeader}>3.3. Legal Obligations</h3>
      <p style={styles.paragraph}>
        We may disclose your information if required to do so by law or if we believe that such action is necessary to:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Comply with legal processes or regulatory obligations.</li>
        <li style={styles.listItem}>Protect the rights, property, or safety of Bizwit Research & Consulting LLP, our users, or the public.</li>
      </ul>
      <h3 style={styles.subHeader}>3.4. Consent</h3>
      <p style={styles.paragraph}>
        We may share your information with third parties if you have given us your explicit consent to do so.
      </p>
      <h2 style={styles.subHeader}>4. Data Security</h2>
      <p style={styles.paragraph}>
        We implement a variety of security measures to protect your personal information, including:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Encryption: Sensitive data is encrypted using industry-standard methods.</li>
        <li style={styles.listItem}>Access Controls: Only authorized personnel have access to your personal data.</li>
        <li style={styles.listItem}>Regular Audits: We perform regular security audits to identify and address potential vulnerabilities.</li>
      </ul>
      <p style={styles.paragraph}>
        Despite these efforts, no system is completely secure, and we cannot guarantee the absolute security of your information.
      </p>
      <h2 style={styles.subHeader}>5. Your Rights and Choices</h2>
      <h3 style={styles.subHeader}>5.1. Access and Correction</h3>
      <p style={styles.paragraph}>
        You have the right to access, update, or correct your personal information. You can do so by logging into your account or contacting us directly.
      </p>
      <h3 style={styles.subHeader}>5.2. Data Portability</h3>
      <p style={styles.paragraph}>
        You have the right to request a copy of your personal data in a structured, commonly used, and machine-readable format.
      </p>
      <h3 style={styles.subHeader}>5.3. Deletion and Erasure</h3>
      <p style={styles.paragraph}>
        You can request the deletion of your personal data. We will honor your request, subject to any legal obligations to retain certain information.
      </p>
      <h3 style={styles.subHeader}>5.4. Objection to Processing</h3>
      <p style={styles.paragraph}>
        You have the right to object to the processing of your personal data under certain circumstances.
      </p>
      <h3 style={styles.subHeader}>5.5. Opt-Out of Marketing</h3>
      <p style={styles.paragraph}>
        You can opt-out of receiving promotional emails by following the unsubscribe link in our emails or by contacting us.
      </p>
      <h2 style={styles.subHeader}>6. International Data Transfers</h2>
      <p style={styles.paragraph}>
        Your information may be transferred to and maintained on servers located outside your state, province, country, or other governmental jurisdiction where data protection laws may differ from those of your jurisdiction. By using our Service, you consent to the transfer of your information to these servers.
      </p>
      <h2 style={styles.subHeader}>7. Data Retention</h2>
      <p style={styles.paragraph}>
        We retain personal data for as long as necessary to provide the Service, comply with legal obligations, resolve disputes, and enforce our agreements. The retention period may vary based on the type of data and the purpose for which we collected it.
      </p>
      <h2 style={styles.subHeader}>8. Children’s Privacy</h2>
      <p style={styles.paragraph}>
        Bizwit Insights is not intended for use by children under the age of 13. We do not knowingly collect personal data from children. If we become aware that we have collected data from a child without parental consent, we will take steps to delete that information.
      </p>
      <h2 style={styles.subHeader}>9. Changes to This Privacy Policy</h2>
      <p style={styles.paragraph}>
        We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any changes by posting the revised policy on this page and updating the "Effective Date."
      </p>
      <h2 style={styles.subHeader}>10. Contact Us</h2>
      <p style={styles.paragraph}>
        If you have any questions about this Privacy Policy or how we handle your information, please get in touch with us at:
      </p>
      <address style={styles.address}>
        Bizwit Research & Consulting LLP
        <br />
        303, Atulya IT Park,
        <br />
        Indore (IN) 452001
        <br />
        Email:{" "}
        <a href="mailto:insights@bizwitresearch.com" style={styles.link}>
          insights@bizwitresearch.com
        </a>
        <br />
        Phone: +91 626710
      </address>
    </div>
  );
};

export default PrivacyPolicy;